var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user-cms"},[_c('Navbar'),_c('router-view',{key:new Date().getTime()}),_c('announcement-modal')],1)}
var staticRenderFns = []

export { render, staticRenderFns }